import { ArticleLevel } from "@/types/models/ArticleLevel.interface";
import {
  AttachmentLevel,
  AttachmentWrapper,
} from "@/types/models/ContentAttachment.interface";
import getBestLanguageMatch from "../getBestLanguageMatch";

/**
 * Map attachment ids to their best matching level based on the current article's grade band.
 * @example: It returns { attachmentId: {...bestMatchingLevelObject}}
 */
function getBestMatchLevelForAttachments(
  attachments: AttachmentWrapper[],
  currentLevel: ArticleLevel,
): Record<string, AttachmentLevel> {
  return attachments.reduce(
    (acc: Record<string, AttachmentLevel>, attachment) => {
      if (attachment?.data?.levels) {
        const levelsWithCurrentLanguage = attachment.data.levels.filter(
          (level) => level.language === currentLevel.language,
        );
        const attachmentLevel = getBestLanguageMatch<AttachmentLevel>(
          levelsWithCurrentLanguage,
          currentLevel,
        );
        if (attachmentLevel) {
          acc[attachment.id] = attachmentLevel;
        }
      }
      return acc;
    },
    {},
  );
}

export default getBestMatchLevelForAttachments;
